module.exports = __webpack_public_path__ + "img/avatar.36635036.png";